import React, { useContext, useEffect, useState } from 'react';
import InsightMenu from '../../components/InsightMenu/InsightMenu';
import DashboardRedirect from '../../components/PlayerInsightDashboardRedirect/PlayerInsightDashboardRedirect';
import InsightNavigationBar from '../../components/InsightNavigationBar/InsightNavigationBar';
import InsightDetails from '../../components/InsightDetails/InsightDetails';
import AuthorInfo from '../../components/AuthorInfo/AuthorInfo';
import About from '../../components/About/About';
import APIClient from '../../helpers/APIClient';
import { insightsContext } from '../../context/insightsContext';
import Styles from './PlayerInsightsLandingPage.module.scss';
import LoadingSpinner from '../../components/ArccosTile/Loading/PlayerInsightLoadingSpinner/PlayerInsightLoadingSpinner';
import NavigationArrows from '../../components/InsightNavigationBar/NavigationArrows/NavigationArrows';

const PlayerInsightsLandingPage = (props) => {
  const insights = useContext(insightsContext);
  const { state } = insights;
  const { data, currentInsight } = state;
  const { toggleModal } = props;

  const [authorInfo, setAuthorInfo] = useState(null);
  const [fetchingAuthorInfo, setFetchingAuthorInfo] = useState(true);

  const getAuthorInfo = () => {
    APIClient.getAuthor(data[currentInsight].author, ((status, response) => {
      setAuthorInfo(response.data);
      setFetchingAuthorInfo(false);
    }));
  };

  useEffect(() => {
    if (data) {
      getAuthorInfo();
    }
  }, [data]);

  useEffect(() => {
    if (currentInsight !== null && currentInsight !== undefined) {
      setFetchingAuthorInfo(true);
      getAuthorInfo();
    }
  }, [currentInsight]);

  return (
    <div>
      {data
        && (
          <div>
            <div className={Styles.redirectButton}>
              <DashboardRedirect onClick={toggleModal} />
            </div>
            <div className={Styles.landingPageContent}>
              <div className={Styles.leftCol}>
                <InsightMenu fetchingAuthorInfo={fetchingAuthorInfo} />
              </div>
              <div className={Styles.centerCol}>
                {
                  fetchingAuthorInfo
                    ? (
                      <div className={Styles.fetchingAuthorContainer}>
                        <InsightNavigationBar fetchingAuthorInfo={fetchingAuthorInfo} />
                        <div className={Styles.loadingContainer}>
                          <LoadingSpinner color={'light'} />
                        </div>
                      </div>
                    )
                    : (
                      <div>
                        <InsightNavigationBar />
                        <InsightDetails
                          authorInfo={authorInfo}
                          fetchingAuthorInfo={fetchingAuthorInfo}
                        />
                        <AuthorInfo authorInfo={authorInfo} />
                      </div>
                    )
                }
              </div>
              <div className={Styles.rightCol}>
                <About />
                <div className={Styles.mobileNavigator}>
                  <NavigationArrows
                    fetchingAuthorInfo={fetchingAuthorInfo}
                    bottomNav={true}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

export default PlayerInsightsLandingPage;
